import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
// import { ConsoleReporter } from 'jasmine';
import { environment } from 'src/environments/environment';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-press-release-details',
  templateUrl: './press-release-details.component.html',
  styleUrls: ['./press-release-details.component.css']
}) 
export class PressReleaseDetailsComponent implements OnInit {

  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute, private encDec: EncryptDecryptService, private route: Router, public translate: TranslateService) { }
  imageUrl = environment.serviceURL + 'storage/app/uploads/';
  backendUrl = environment.serviceURL;
  content_apiresponse: any;
  mediaResponse: any;
  pressid: any;

  language: any = '';

  ngOnInit(): void {
    this.language = sessionStorage.getItem('locale'); //dynamic content language translation 
    let schemeArr: any = [];
    this.routerparam.paramMap.subscribe((params: ParamMap) => {
      let encSchemeId = params.get('id')
      if (encSchemeId != "") {
        let schemeStr = this.encDec.decText(encSchemeId);
        schemeArr = schemeStr.split(':');
        this.pressid = schemeArr[0];
      }
    });
    this.getPressReleaseDetails(this.pressid);
  }

  title: any;
  publishDate: any;
  featureImage: any;
  description: any;
  uploadDocument: any;
  getPressReleaseDetails(id: any) {
    let params = [{
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": '',
      "orderBy": [{ "columnName": "intId", "type": "DESC" }],
      "condition": [
        { "columnName": "VCHPUBLISH_DATE", "operator": "<=", "value": new Date(), "joinoperator": "and" },
        // { "columnName": "VCHACH_DATE", "operator": ">", "value": new Date(), "joinoperator": "and" },
        { "columnName": "VCHMEDIA_TYPE", "operator": "=", "value": 4, "joinoperator": "and" },
        { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
        { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" },
        { "columnName": "intId", "operator": "=", "value": id, "joinoperator": "and" },
      ],
      "viewParameters": ""
    }];
    this.fciwebservice.getAllMediaType(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.mediaResponse = response.result.sec_1;
           
            this.title = this.mediaResponse[0].title;
            this.publishDate = this.mediaResponse[0].publishDate;
            this.featureImage = this.mediaResponse[0].uploadImage;
            this.description = this.mediaResponse[0].description;
            this.uploadDocument = this.mediaResponse[0].uploadDocument;
          } 

      }
    });

  }

  htmldecode(str: any){
    return this.encDec.decodeHtml(str);
  }

  
  checkFileExists(obj:any):boolean{
    if(obj[0].uploadDocument==""){
      return false;
    }
    if(obj[0].uploadDocument_details==undefined){
      return false;
     }
    if(obj[0].uploadDocument_details.fileSize==undefined){
      return false;
     }
   if(obj[0].uploadDocument_details.fileSize==""){
    return false;
   }
  return true;
  }


  checkFileType(data:any):any{
    let ext:any,fileType:any;
    ext= ['webp','jpeg', 'jpe', 'png', 'gif', 'jpg', 'pdf', 'PNG','xlsx','xls','csv','docx','doc'];
    if(data==""){
      return false; 
    }  
    if(data.uploadDocument==""){
      return false; 
    }
    if(data.uploadDocument_details==undefined){
      return false; 
    }
    if(data.uploadDocument_details.fileType==undefined){
      return false; 
    }
    if(data.uploadDocument_details.fileType==''){
      return false; 
    }
    fileType=data.uploadDocument_details.fileType.toLowerCase();
    if(fileType=='xlsx' || fileType=='xls' || fileType=='csv'){
      return {'fileType':fileType,'file': `|| <i class="fa fa-file-excel-o" aria-hidden="true"></i> ${fileType} || `}; 
    } else if(fileType=='docx' || fileType=='doc'){
      return {'fileType':fileType,'file':`|| <i class="fa fa-file-word-o" aria-hidden="true"></i> ${fileType} || `}; 
    } else if(fileType=='pdf'){
      return {'fileType':fileType,'file':`|| <i class="fa fa-file-pdf-o" aria-hidden="true"></i> ${fileType} || `}; 
    } else {
      return {'fileType':fileType,'file':`|| <i class="fa fa-file-text" aria-hidden="true"></i> ${fileType} || `}; 
    }
  }


}
